import axios from 'axios';
import Cookies from 'js-cookie';
import * as types from '../mutation-types';
import UsersService from '~/services/users';

// state
export const state = {
  user: null,
  token: Cookies.get('token'),
  cookiesAccepted: Cookies.get('accepted')
}

// getters
export const getters = {
  user: state => state.user,
  isAdmin: state => state.user && state.user.roles.indexOf('admin') !== -1,
  isCurator: state => state.user && state.user.roles.indexOf('curator') !== -1,
  isTeacher: state => state.user && state.user.roles.indexOf('teacher') !== -1,
  role: state => {
    let role = 'guest';
    if (state.user) {
      if (state.user.roles.indexOf('user') !== -1) {
        role = 'user';
      }
      if (state.user.roles.indexOf('teacher') !== -1) {
        role = 'teacher';
      }
      if (state.user.roles.indexOf('curator') !== -1) {
        role = 'curator';
      }
      if (state.user.roles.indexOf('admin') !== -1) {
        role = 'admin';
      }
    }
    return role;
  },
  token: state => state.token,
  cookiesAccepted: state => state.cookiesAccepted,
  check: state => state.user !== null
}

// mutations
export const mutations = {
  [types.SAVE_TOKEN] (state, { token, remember }) {
    state.token = token;
    Cookies.set('token', token, { expires: remember ? 365 : null });
  },
  [types.ACCEPT_COOKIES] (state) {
    state.cookiesAccepted = true;
    Cookies.set('accepted', true, { expires: 365 });
  },

  [types.FETCH_USER_SUCCESS] (state, { user }) {
    state.user = user;
  },

  [types.FETCH_USER_FAILURE] (state) {
    state.token = null;
    Cookies.remove('token');
  },

  [types.LOGOUT] (state) {
    state.user = null;
    state.token = null;

    Cookies.remove('token');
  },

  [types.UPDATE_USER] (state, { user }) {
    state.user = user;
  },

  [types.USERS_STUDY] (state, lesson) {
    const studiedLesson = state.user.user_lessons.find(l => parseInt(l.id) === parseInt(lesson.id));
    if (!studiedLesson) {
      state.user.user_lessons.push(lesson);
    }
  },
}

// actions
export const actions = {
  saveToken ({ commit, dispatch }, payload) {
    commit(types.SAVE_TOKEN, payload);
  },

  async fetchUser ({ commit }) {
    try {
      const { data } = await axios.get('/api/user')

      commit(types.FETCH_USER_SUCCESS, { user: data });
    } catch (e) {
      commit(types.FETCH_USER_FAILURE);
    }
  },

  updateUser ({ commit }, payload) {
    commit(types.UPDATE_USER, payload);
  },

  async logout ({ commit }) {
    try {
      await axios.post('/api/logout');
    } catch (e) {
      console.warn(e);
    }

    commit(types.LOGOUT)
  },

  async study ({ commit }, lesson) {
    await UsersService.studyLesson(lesson.id);
    commit(types.USERS_STUDY, lesson);
  },

  acceptCookies ({ commit }) {
    commit(types.ACCEPT_COOKIES);
  },
}
